import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { selectReadOnly } from 'store/Faraday/selectors';
import { selectActiveWorkspacesCount } from 'store/Global/selectors';
import { openModal } from 'store/modals/actions';
import { MODAL_CANT_CREATE } from 'store/modals/modals';
import { RiFileDownloadLine as DownloadLine, RiFileEditLine as EditLine } from 'react-icons/ri';
import useClickOutside from 'Hooks/useClickOutside';
import ImportFileCreationModal from 'Screens/Contextualization/ManageEditCreate/components/ImportFileCreationModal';
import { getWorkspaces } from 'Screens/Contextualization/Workspaces/actions/Actions';
import {
  Dropdown, DropdownItem, DropdownText, DropdownWrapper, PlusIcon, Wrapper
} from './styled';

const CreateActions = ({ setVisibilityCreateModal, entity }) => {
  const [showImportModal, setShowImportModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef();
  const intl = useIntl();
  const addText = intl.formatMessage({ id: 'host.create' });
  const readOnly = useSelector(selectReadOnly);
  const canUpdate = entity === 'assetsGeneral' || !readOnly;
  const activeWorkspacesCount = useSelector(selectActiveWorkspacesCount);
  const dispatch = useDispatch();

  useClickOutside(dropdownRef, () => setShowDropdown(false));

  const handleShow = () => {
    if (entity === 'assetsGeneral' && !activeWorkspacesCount) {
      dispatch(openModal(MODAL_CANT_CREATE));
    } else if (canUpdate) {
      setVisibilityCreateModal(true);
    }
    setShowDropdown(false);
  };

  const handleShowImportFromFile = () => {
    setShowImportModal(true);
    setShowDropdown(false);
    if (entity === 'assetsGeneral') dispatch(getWorkspaces(false, false));
  };

  const handleDropdown = () => {
    if (canUpdate) setShowDropdown(!showDropdown);
  };

  return (
    <Wrapper ref={ dropdownRef }>
      <DropdownWrapper onClick={ handleDropdown } title={ addText } $disabled={ entity !== 'assetsGeneral' && readOnly }>
        <PlusIcon />
        <DropdownText>{ addText }</DropdownText>
      </DropdownWrapper>
      { showDropdown &&
        <Dropdown>
          <DropdownItem onClick={ handleShow } role="button" aria-label="Manual Creation" type="button">
            <EditLine size="1.3em" color="#5a6b7d" />
            Manual Creation
          </DropdownItem>
          <DropdownItem onClick={ handleShowImportFromFile } role="button" aria-label="Import from File" type="button">
            <DownloadLine size="1.3em" color="#5a6b7d" />
            Import from File
          </DropdownItem>
        </Dropdown>
      }
      <ImportFileCreationModal show={ showImportModal } handleClose={ () => setShowImportModal(false) } entity={ entity } />
    </Wrapper>
  );
};

export default CreateActions;
